import * as React from 'react';
import { getHashArray, scrollToElement, } from '@core-front/helper';
const HashTrigger = (props) => {
    const { renderWrapper = true, scrollOnMatch = true, onMatch, id, children, } = props;
    const isInitial = React.useRef(true);
    React.useEffect(() => {
        const handleHashChange = (event) => {
            const hashes = getHashArray();
            if (hashes && hashes.indexOf(id) !== -1) {
                const cb = () => {
                    // trigger scroll only if event was not from autoscroll
                    if (!(event && event.detail && event.detail.fromAutoscroll) && scrollOnMatch) {
                        scrollToElement(id, undefined, undefined, true);
                    }
                };
                if (onMatch) {
                    onMatch(id, true, cb);
                }
                else {
                    cb();
                }
            }
        };
        if (isInitial.current) {
            isInitial.current = false;
            handleHashChange();
        }
        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [id, onMatch, scrollOnMatch, isInitial]);
    return renderWrapper ? (React.createElement("div", { id: id }, children)) : (React.createElement(React.Fragment, null, children));
};
export { HashTrigger as default, };
